import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class TipoMovimientoService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  GetTiposMovimiento(callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query {
          tipo_movimiento {
            obtenerTipoMovimiento(
              filtro: {
                exacto: {
                  activo:true
                }
              }
            )
            {
              respuesta {
                registros {
                  codigo
                  nombre
                  operacion
                }
              }
            }
          }
        }
        `,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.tipo_movimiento.obtenerTipoMovimiento
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerSegunFiltroNombre(nombre: string, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($nombre: String) {
          tipo_movimiento {
            obtenerSegunFiltro(filtro: {exacto: {nombre: $nombre}}) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                registros {
                  codigo
                  nombre
                  descripcion
                  operacion
                  activo
                }
                totalPaginas
                totalRegistros
              }
            }
          }
        }
        `,
        variables: {
          nombre: nombre
        },
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.tipo_movimiento.obtenerSegunFiltro
        callback({ mensajes, respuesta })
      }
    );
  }

  cambiaEstado(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        mutation($entidad: tipo_movimientoInputType) {
          tipo_movimiento {
            cambiaEstado(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                activo
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.tipo_movimiento.cambiaEstado
        callback({ mensajes, respuesta })
      }
    );
  }

  guardar(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        mutation($entidad: tipo_movimientoInputType) {
          tipo_movimiento {
            guardar(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                nombre
                descripcion
                operacion
                activo
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.tipo_movimiento.guardar
        callback({ mensajes, respuesta })
      }
    );
  }

  GetOperaciones(callback: Function) {
    const respuesta = {
      registros: [
        { operacion: 1, nombre: 'Entrada' },
        { operacion: -1, nombre: 'Salida' },
        { operacion: 2, nombre: 'Entrada / Salida' },
      ]
    }
    callback({ respuesta })
  }
}
